namespace $.$$ {

	export type $shm_hitalama_command_palette_item = {
		id: string
		title: string
	}

	export class $shm_hitalama_command_palette extends $.$shm_hitalama_command_palette {

		items(): readonly $shm_hitalama_command_palette_item[] {
			return []
		}

		@ $mol_mem
		items_filtered() {
			const query = this.query().trim().toLocaleLowerCase()
			if( !query ) return this.items()

			return this.items().filter( item => {
				return item.title.toLocaleLowerCase().includes( query )
			} )
		}

		commands_filtered() {
			return this.items_filtered()
		}

		command_rows(): readonly $mol_view[] {
			return this.commands_filtered().map( item => this.Command_row( item.id ) )
		}

		command_title( id: string ) {
			return this.items().find( item => item.id === id )?.title ?? ''
		}

		command_selected( id: string ) {
			return this.selected_command()?.id === id
		}

		selected_command() {
			const commands = this.commands_filtered()
			if( !commands.length ) return null

			const selected = this.selected_id()
			return commands.find( command => command.id === selected ) ?? commands[0]
		}

		select_shift( shift: number ) {
			const commands = this.commands_filtered()
			if( !commands.length ) return

			const selected = this.selected_command()
			const current = selected ? commands.indexOf( selected ) : 0
			const next = ( current + shift + commands.length ) % commands.length
			const id = commands[ next ].id
			this.selected_id( id )
			this.command_scroll_to( id )
		}

		@ $mol_action
		command_scroll_to( id: string ) {
			new this.$.$mol_after_frame( ()=> {
				this.Command_row( id ).dom_node().scrollIntoView({
					block: 'nearest',
				})
			} )
		}

		panel_visible(): readonly $mol_view[] {
			return this.opened() ? super.panel_visible() : []
		}

		@ $mol_mem
		search_focus() {
			if( !this.opened() ) return
			this.$.$mol_wait_timeout( 0 )
			this.Search().focused( true )
		}

		@ $mol_mem
		pointerdown_handler() {
			return $mol_wire_async( ( event: PointerEvent ) => {
				if( !this.opened() ) return
				if( this.panel_hovered() ) return
				this.close()
			} )
		}

		@ $mol_action
		close() {
			this.opened( false )
			this.query( '' )
			this.selected_id( '' )
		}

		@ $mol_action
		submit( event?: Event ) {
			// event?.preventDefault()

			const command = this.selected_command()
			if( !command ) return

			this.command_click( command.id, event )
		}

		@ $mol_action
		search_keydown( event?: KeyboardEvent ) {
			if( !event ) return null

			switch( event.key ) {
				case 'ArrowDown':
					event.preventDefault()
					this.select_shift( 1 )
					break
				case 'ArrowUp':
					event.preventDefault()
					this.select_shift( -1 )
					break
			}

			return event
		}

		@ $mol_action
		command_click( id: string, event?: Event ) {
			// event?.preventDefault()
			this.item_submit( id, event )
			this.close()
		}

		@ $mol_action
		item_submit( id: string, event?: Event ) {
			return null
		}

	}

}
